<template lang="pug">
    v-container
        v-row
            h1 Registro de correos
            v-spacer
            Enviar_correo_dialog(:se_envia_a_todos='true')

        v-row
            v-list.transparent
                v-list-item(v-for='{correo, suscrito_el}, i in correos' :key='i')
                    Correo_list(:correo='correo' :suscrito_el='suscrito_el')
</template>
<script>
import {} from '@/Helper'
export default {
    computed: {
        correos(){
            return this.$contenido.correos || []
        },
    },
    components: {
        Enviar_correo_dialog: ()=>import('./componentes/enviar_correo_dialog'),
        Correo_list: ()=>import('./componentes/correo_list'),
    },
}
</script>